// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V5yE","col":"styles_col__10Z2p"};